// extracted by css-extract-rspack-plugin
export default {"header":"KHswq","desktop":"ABJ9C","mobile":"GLJLH","headerBg":"kS9I8","logo":"EN6qT"};